import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { createUser } from '@/store/thunks/userThunks';
import { Input, Button } from '@/components/ui';

const schema = Yup.object({
  code: Yup.string().required('Code obligatoire'),
  nom: Yup.string().required('Nom obligatoire'),
  prenom: Yup.string().required('Prénom obligatoire'),
});

interface UserFormProps {
  onClose: () => void;
  onSuccess?: () => void;
}

export default function UserForm({ onClose, onSuccess }: UserFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: { code: '', nom: '', prenom: '' },
    validationSchema: schema,
    onSubmit: async (values) => {
      const res = await dispatch(createUser(values));
      if (createUser.fulfilled.match(res)) {
        onSuccess?.();
        onClose();
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="w-full max-w-md space-y-4">
      <Input
        label="Code"
        id="code"
        {...formik.getFieldProps('code')}
        error={formik.touched.code ? formik.errors.code : undefined}
      />
      <Input label="Nom" id="nom" {...formik.getFieldProps('nom')} error={formik.touched.nom ? formik.errors.nom : undefined} />
      <Input
        label="Prénom"
        id="prenom"
        {...formik.getFieldProps('prenom')}
        error={formik.touched.prenom ? formik.errors.prenom : undefined}
      />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose}>
          Annuler
        </Button>
        <Button type="submit" loading={formik.isSubmitting}>
          Créer
        </Button>
      </div>
    </form>
  );
}
